import React from "react";

import { PasswordConstraint } from "@legacyComponents/login/PasswordConstraint";

interface Props {
  isAdvancedSecurity: boolean;
  passwordLength: number;
  isValid: boolean;
  isValidLength: boolean;
  isValidLowercase?: boolean;
  isValidNumeric?: boolean;
  isValidPasswords: boolean;
  isValidSpecialCharacter?: boolean;
  isValidUppercase?: boolean;
}

const PasswordValidation: React.FC<Props> = props => {
  const { isAdvancedSecurity, passwordLength } = props;

  let advancedPasswordConstraints = <></>;
  if (isAdvancedSecurity) {
    const { isValidNumeric, isValidUppercase, isValidLowercase, isValidSpecialCharacter } = props;
    advancedPasswordConstraints = (
      <>
        <PasswordConstraint label="Must have at least 1 number" isValid={isValidNumeric} />
        <PasswordConstraint
          label="Must have at least 1 uppercase letter"
          isValid={isValidUppercase}
        />
        <PasswordConstraint
          label="Must have at least 1 lowercase letter"
          isValid={isValidLowercase}
        />
        <PasswordConstraint
          label="Must have at least 1 special character"
          isValid={isValidSpecialCharacter}
        />
      </>
    );
  }

  const { isValidLength, isValidPasswords } = props;

  return (
    <div className="password-constraints">
      <PasswordConstraint
        label={`Must meet minimum length requirement ${passwordLength}`}
        isValid={isValidLength}
      />
      {advancedPasswordConstraints}
      <PasswordConstraint label="Both passwords must match" isValid={isValidPasswords} />
    </div>
  );
};

export { PasswordValidation };
